/**
 * Created by gerald on 03.03.14.
 */

angular.module('olivioConfiguratorApp')
  .controller('QuoteCtrl', function (env, $scope, $rootScope, Model, Storage, Data, $http) {
    //console.log('init QuoteCtrl');

    $scope.isVisible = false;

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;

    $scope.data = Data;
    $scope.quoteMessage = '';

    $scope.submitting = false;
    $scope.submitSuccess = false;
    $scope.submitError = false;


    $scope.openQuoteForm = function () {
      $scope.isVisible = true;
    };
    $scope.closeQuoteForm = function () {
      $scope.isVisible = false;
      $scope.submitting = false;
      $scope.submitSuccess = false;
      $scope.submitError = false;
    };

    $scope.submitQuoteForm = function () {
      console.log('submitQuote');
      $scope.submitting = true;
      $scope.model.person.entered = true;

      Storage.saveStateToServer(
        function (token) {
          var url = env.mailUrl.replace(':token', token);
          $http({
            method: 'post',
            url: url,
            data: angular.extend({quoteMessage: $scope.quoteMessage}, Model.model),
            cache: false
          })
            .then(quoteSubmittedSuccess, quoteSubmittedError);
        },
        quoteSubmittedError);
    };

    var quoteSubmittedSuccess = function () {
      console.log('success');
      $scope.submitting = false;
      $scope.submitSuccess = true;
    };

    var quoteSubmittedError = function () {
      console.log('error');
      $scope.submitting = false;
      $scope.submitError = true;
    };
  });
